export const drawerWidth = 300;
export const toolbarHeight = 64;
